import { useEffect } from "react";
import { usePlayer } from "@/context/PlayerContext";

const isEditable = (el) => el && (el.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName));

export const PlayerShortcuts = () => {
  const p = usePlayer();
  useEffect(() => {
    const onKey = (e) => {
      if (e.ctrlKey || e.metaKey || e.altKey || isEditable(document.activeElement) || document.querySelector("[role=dialog]")) return;
      const k = e.key.toLowerCase();
      if (e.code === "Space" && p.current) { e.preventDefault(); p.toggle(); }
      else if (e.shiftKey && e.key === "ArrowRight") { e.preventDefault(); p.next(); }
      else if (e.shiftKey && e.key === "ArrowLeft") { e.preventDefault(); p.prev(); }
      else if (k === "m") p.setMuted(!p.muted);
      else if (k === "s") p.setShuffle(!p.shuffle);
      else if (k === "r") p.cycleRepeat();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [p]);
  return null;
};
